import { Component, ElementRef, TemplateRef, ViewChild, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';

export interface TrainingGroupInterface {
  groupId: number;
  groupName: string;
  groupDescription: string;
  ccReminderEmailToRm: string;
  ccEmailToRm: string;
  addlDueReminderEmails: string;
  addlDueEscalationEmails: string;
  maxAttemptEscalationEmails: string;
  isActive: string;
  updateReason: string;
  deleteReason: string;
  createdByUser: string;
  createdOn: Date;
  updatedByUser: string;
  updatedOn: Date;
}

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-tms-groups',
  templateUrl: './tms-groups.component.html',
  styleUrls: ['./tms-groups.component.scss']
})
export class TmsGroupsComponent implements OnInit {

  searchText: any;
  searchValue: any;
  isProcessing = true;
  _temp: any = {};
  columnLists: any = {};
  trainingGroupDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];

  auditTrail: any = {};
  visibleAuditTrail: boolean = false;

  constructor(public dialog: MatDialog, readonly appService: AppService, public router: Router, readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, readonly elem: ElementRef) { }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages

  allowOnlyAllowedChars(event: KeyboardEvent): void {
    const allowedPattern = /^[a-zA-Z0-9\s\-._()/\\]$/;
    const inputChar = event.key;
    if (!allowedPattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  readonly users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (Number.isNaN(page) || page < 1) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.trainingGroupDataForGrid.length, page, this.perPage, targetpage);
    if (page > this.pager.totalPages) {
      return;
    }
    this.pagedItems = this.trainingGroupDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  getcallMethod() {
    this.isProcessing = true;
    this.trainingGroupDataForGrid = [];
    const data = {

      gridName: "TRAINING_GROUP"
    };
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        // 1. Coalescing Operator (??)
        response.orderByClause = response.orderByClause ?? "";
        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "TMS_GROUPS_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist ?? "",
          blobColumnlist: response.bloblist ?? ""
        };

        this.reportObj = { ...data1, ...data };

        // 2. Nested Subscription 1
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.trainingGroupDataForGrid = response1;
            this.visibleAuditTrail = false;

            // Parse Lists
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");

            // 3. Mapping Arrays (Logic Cleanup)
            // We use a temporary array to hold valid columns to avoid splicing issues
            const validColumns = [];
            const validLabels = [];
            const validSizes = [];

            // Loop through columns and check if they are invisible
            // Using standard loop here because we need the index to access parallel arrays
            for (let i = 0; i < data1.columnsListarray.length; i++) {
              const colName = data1.columnsListarray[i];

              // Only add if NOT in the invisible list
              if (!data1.invisibleColumnarray.includes(colName)) {
                validColumns.push(colName);

                validLabels.push({
                  fieldColumnarray: data1.fieldColumnarray[i],
                  width: (data1.fieldSizeListArray[i] ?? '0') + 'px'
                });

                validSizes.push((data1.fieldSizeListArray[i] ?? '0') + 'px');
              }
            }

            // Assign filtered lists
            this.columnLists.columnsListarray = validColumns;
            this.columnLists.fieldColumnarray = validLabels;
            this.columnLists.fieldSizeListArray = validSizes;
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;

            const tableData = {
              tablename: data1.tableOrViewName
            };

            this.columnLists.columnsListarray1 = [];

            // 4. Nested Subscription 2
            this.appService.tableFieldsDataType(tableData).subscribe({
              next: (response2: any) => {
                this.dataTypeList = response2;

                // Map data types using for...of
                for (const colName of this.columnLists.columnsListarray) {
                  let currentType = "textbox";

                  // Find matching type
                  for (const typeItem of this.dataTypeList) {
                    if (typeItem.columnName === colName) {
                      currentType = typeItem.fieldType;
                      break;
                    }
                  }

                  this.columnLists.columnsListarray1.push({
                    columnsListarray: colName,
                    dataType: currentType,
                    width: this.columnLists.fieldSizeListArray
                  });
                }

                // Convert Checkbox Y/N to boolean using for...of
                for (const row of this.trainingGroupDataForGrid) {
                  for (const typeItem of this.dataTypeList) {
                    if (typeItem.fieldType === 'CHECKBOX') {
                      row[typeItem.columnName] = row[typeItem.columnName] === "Y";
                    }
                  }
                }

                // Pagination & Finalize
                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.setPage(1, 0);

                this.message.gridList = this.trainingGroupDataForGrid;
                this.collectionSize = this.trainingGroupDataForGrid.length;
                this.totalPages = Math.ceil(this.trainingGroupDataForGrid.length / this.itemsPerPage);
                this.dynamicLabelCall();
                this.isProcessing = false;
              },
              error: (error) => {
                this.isProcessing = false;
                throw error;
              }
            });
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  ngOnInit() {
    this.getcallMethod();
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.trainingGroupDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.trainingGroupDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })
  }

  onClick(event: any) {
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;
    this.childCheckBoxs = isChecked;
    for (const row of this.trainingGroupDataForGrid) {
      row.childCheckBoxs = isChecked;
    }
  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.trainingGroupDataForGrid[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.GROUP_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.priviousSelectedValue = idx;
    this.visibleAuditTrail = this.trainingGroupDataForGrid.some((list: any) => list.childCheckBoxs);
  }

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  groupName: any;
  groupNameRequiredMsg: any;
  fieldValidation() {
    this.groupName = document.getElementById('groupName') as HTMLInputElement;
    this.groupNameRequiredMsg = document.getElementById('groupName-required-msg') as HTMLInputElement;

    if (this.trainingGroupFieldData.groupName == "") {
      this.groupName.style.border = '1px solid red';
      this.groupNameRequiredMsg.style.display = 'block';
    } else {
      this.groupName.style.border = 'none';
      this.groupNameRequiredMsg.style.display = 'none';
    }
  }


  trainingGroupFieldData: any = {};
  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '70%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;
  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create Training Group";
    this.trainingGroupFieldData.groupName = '';
    this.trainingGroupFieldData.groupId = null;
    this.trainingGroupFieldData.groupDescription = null;
    this.trainingGroupFieldData.ccReminderEmailToRm = false;
    this.trainingGroupFieldData.ccEmailToRm = false;

    this.trainingGroupFieldData.addlDueReminderEmails = null;
    this.trainingGroupFieldData.addlDueEscalationEmails = null;
    this.trainingGroupFieldData.maxAttemptEscalationEmails = null;
    this.trainingGroupFieldData.isActive = true;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  previousData: any;
  getTmsGroupsVwData: any = [];
  openEditPopup(editRowData: any) {
    this.isProcessing = true;
    this.previousData = editRowData;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.visibleReasonForUpdateField = true;
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = "Update Training Group";
    this.appService.getTmsGroupsVwDetails().subscribe((response: any) => {
      this.getTmsGroupsVwData = response;
      for (const group of this.getTmsGroupsVwData) {
        if (this.previousData.GROUP_ID === group.groupId) {
          this.trainingGroupFieldData = group;
          this.trainingGroupFieldData.ccReminderEmailToRm = group.ccReminderEmailToRm === 'Y';
          this.trainingGroupFieldData.ccEmailToRm = group.ccEmailToRm === 'Y';
          this.trainingGroupFieldData.isActive = group.isActive === 'Y';
          break;
        }
      }
      this.isProcessing = false;
      this.router.navigate(['/dashboard/trainingGroupDetail'], {
        state: {
          trainingGroupFieldData: this.trainingGroupFieldData
        }
      });
    })

  }

  refreshGridData() {
    this.isProcessing = true;
    this.getcallMethod();
  }

  openSnackbar: any;
  addAndEditFunction(trainingGroupFieldData: any) {
    this.isProcessing = true;

    if (!trainingGroupFieldData.groupName) {
      this.fieldValidation();
      this.isProcessing = false;
      return;
    }

    const payload = this.preparePayload(trainingGroupFieldData);

    const apiRequest$ = this.operationFlag === 'ADD'
      ? this.appService.createTmsGroup(payload)
      : this.appService.updateTmsGroup(payload);

    apiRequest$.subscribe({
      next: (response: any) => this.handleResponse(response),
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  preparePayload(data: any): any {
    const commonData = {
      groupName: data.groupName,
      groupDescription: data.groupDescription,
      ccReminderEmailToRm: data.ccReminderEmailToRm ? 'Y' : 'N',
      ccEmailToRm: data.ccEmailToRm ? 'Y' : 'N',
      addlDueReminderEmails: data.addlDueReminderEmails,
      isActive: data.isActive ? 'Y' : 'N',
      addlDueEscalationEmails: data.addlDueEscalationEmails,
      maxAttemptEscalationEmails: data.maxAttemptEscalationEmails,
      ...(this.operationFlag !== 'ADD' && {
        groupId: data.groupId,
        ...data
      })
    };

    if (this.operationFlag !== 'ADD') {
      delete commonData.createdOn;
      delete commonData.updatedOn;
    }

    return commonData;
  }

  handleResponse(response: any) {
    this.isProcessing = false;

    if (response.resultType === 'S') {
      this.visibleAddAndEditPopup.close();
      this.getcallMethod();
    }

    this.showNotification(response);
  }

  showNotification(response: any) {
    const isSuccess = response.resultType === 'S';

    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: isSuccess ? 5000 : undefined,
      data: {
        message: response.result,
        type: isSuccess ? 'Success' : 'Error',
        buttonLabel: "Ok",
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: isSuccess ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => sb.dismiss());
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteTrainingGroupGroupId: any;
  openDeletePopup(deleteRowData: any) {
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Training Group";
    this.deleteTrainingGroupGroupId = deleteRowData.GROUP_ID;
    if (this.trainingGroupFieldData.deleteReason != undefined) {
      this.trainingGroupFieldData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteTrainingGroupData: any;
  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      this.deleteTrainingGroupData = {
        groupId: this.deleteTrainingGroupGroupId,
        deleteReason: this.trainingGroupFieldData.deleteReason,
      };
      this.appService.deleteTmsGroup(this.deleteTrainingGroupData).subscribe({
        next: (response: any) => {
          this.isProcessing = false;

          if (response.resultType === 'S') {
            this.visibleDeletePopup.close();
            this.getcallMethod();
          }
          this.showNotification(response);
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  goToDetailPage(editRowData: any, i: any) {
    if (i === 0) {
      this.previousData = editRowData;
      this.isProcessing = true;

      this.appService.getTmsGroupsVwDetails()
        .subscribe({
          next: (response: any) => {
            this.getTmsGroupsVwData = response;

            for (const group of this.getTmsGroupsVwData) {
              if (this.previousData.GROUP_ID === group.groupId) {
                this.trainingGroupFieldData = group;
                this.trainingGroupFieldData.ccReminderEmailToRm = group.ccReminderEmailToRm === 'Y';
                this.trainingGroupFieldData.ccEmailToRm = group.ccEmailToRm === 'Y';
                this.trainingGroupFieldData.isActive = group.isActive === 'Y';
                break;
              }
            }
            this.isProcessing = false;
            this.router.navigate(['/dashboard/trainingGroupDetail'], {
              state: {
                trainingGroupFieldData: this.trainingGroupFieldData
              }
            });
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.trainingGroupDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, trainingGroup: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : trainingGroup.GROUP_ID;
    this.auditTrail.gridName = 'TRAINING_GROUP';
    this.auditTrail.report_And_Popup_Name = 'Trainings Group Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(trainingGroup);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Trainings Group Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  dynamicLabel: any = null;
  label: any = [];
  dynamicLabelCall() {
    this.isProcessing = true;

    const data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0,
    };

    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (response: any) => {
        this.label = response;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[user.columnName] = user.changedFieldName;
          return acc;
        }, {});

        this.isProcessing = false;
      },
      error: (error: any) => {
        this.isProcessing = false;
        console.error(error);
      }
    });
  }
}
